module.exports = __webpack_public_path__ + "media/images/s2ep1-cindy-c8e4e15b4647358ea20ef46bc49ca3b2.png";